<template>
  <div class="videoMayLike">
    <div class="videoMayLike-title">猜你喜欢</div>
    <ul class="videoMayLike-list">
      <video-item
        v-for="video of data"
        :key="video.id"
        class="videoMayLike-list-item"
        :video-id="video.id"
        :img="video.coverbase64"
        :title="video.title"
        :tags="video.labls"
        :views="video.pageviews"
        v-on="$listeners"/>
    </ul>
    <div
      v-if="showMore"
      class="videoMayLike-more">
      <button
        class="videoMayLike-more-button"
        @click="$emit('click-more')">点击更多</button>
    </div>
  </div>
</template>

<script>
import VideoItem from '@/components/VideoItem'
export default {
  name: 'VideoMayLike',
  components: {
    VideoItem
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    showMore: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.videoMayLike {
  width: 100%;
}

.videoMayLike-title {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  padding-left: 8px;
  font-size: 15px;
  font-weight: 500;
  line-height: 30px;
  color: rgba(255, 255, 255, 1);
  text-align: left;
}

.videoMayLike-title::after {
  position: absolute;
  top: 50%;
  left: 0;
  width: 3px;
  height: 40%;
  content: "";
  background: #eab87f;
  transform: translateY(-50%);
}

.videoMayLike-list {
  width: 100%;
  padding: 0 0;
  margin: 0 0;
  list-style: none;
}

.videoMayLike-list > .videoMayLike-list-item:last-child::after {
  height: 0;
}

.videoMayLike-more {
  width: 100%;
  height: 40px;
}

.videoMayLike-more-button {
  height: 40px;
  margin: 0 auto;
  font-size: 15px;
  font-weight: 400;
  line-height: 40px;
  color: #eab87f;
  background-color: transparent;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/VideoMayLike.vue